import { customFetch } from "@/client/custom-fetch";

import { mapProductToBackend, mapProductToFrontend } from "./products.mappers";
import { EProductType, TProduct } from "./products.type";

const API_BASE = "/products";
const ALLOWED_TYPES_BASE = "/allowed-product-types";

export const getProducts = async () => {
  const data = await customFetch<TProduct[]>(`${API_BASE}`);
  return data.map(product => mapProductToFrontend(product));
};

export const getAllowedProductTypes = async () => {
  return customFetch<EProductType[]>(ALLOWED_TYPES_BASE);
};

export const getProduct = async (id: string) => {
  const data = await customFetch<TProduct>(`${API_BASE}/${id}`);
  return mapProductToFrontend(data);
};

export const createProduct = async (data: any) => {
  const backendData = mapProductToBackend(data);
  
  // Remove campos null/undefined/string vazia antes de enviar
  const finalData = Object.fromEntries(
    Object.entries(backendData).filter(([_, value]) => {
      return value !== null && value !== undefined && value !== '';
    })
  );

  return await customFetch<any>(`${API_BASE}`, {
    method: "POST",
    body: JSON.stringify(finalData),
  });
};

export const updateProduct = async (id: string, data: any) => {
  const backendData = mapProductToBackend(data) as Record<string, unknown>;
  // `@IsOptional()` + `@IsUUID()` no Nest não tratam string vazia como omitido — o PATCH falhava.
  for (const key of ["payment_gateway_id", "insurance_company_id"]) {
    if (backendData[key] === "") {
      delete backendData[key];
    }
  }

  return customFetch<any>(`${API_BASE}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(backendData),
  });
};

export const deleteProduct = async (id: string) => {
  return customFetch<TProduct>(`${API_BASE}/${id}`, {
    method: "DELETE",
  });
};
